import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-challenge-v004',
  templateUrl: './challenge-v004.component.html',
  styleUrls: ['./challenge-v004.component.scss']
})
export class ChallengeV004Component implements OnInit {

  @Input() timer;

  constructor() { }

  ngOnInit(): void {
  }

}
